<!-- <template>
  <div class="cos">Coming soon……</div>
</template>

<style scoped>
  .cos {
    text-align: center;
    height: 50vh;
  }
</style> -->

 <template>
  <v-app>
    <v-main>
      <div class="my-10 bg-secondary ma-auto pa-2">
        <div
          class="text-sm-center my-5"
          style="font-family: heisei-mincho-std, serif;font-size: x-large;"
        >
        エルミナージュOriginal<br/>DLCフェイスアイコン使用方法
        </div>
        <!-- <v-img
          :width="800"
          aspect-ratio="16/9"
          cover
          src="http://d-mebius.com/elminages/img/ss_st.jpg"
          class="ma-auto"
        ></v-img> -->
         <div class="d_area">
          <SubTitle :TitleName="'◆はじめに'" />
        <p
          class="pa-3 ma-auto"
        >本体内にあるアカウントで購入（特典の引き換え含む）を行っているかをご確認ください。<br/>
※特典は商品を購入した店舗で受け取ってください
        </p>
          <SubTitle :TitleName="'◆コードの入力'" />
        <p
          class=" pa-3 ma-auto"
        >Nintendo Switchのニンテンドーeショップでコードを入力してください。<br/>
        入力方法の詳細は<a href="https://support-jp.nintendo.com/app/answers/detail/a_id/35934/p/8664">任天堂のサポートページ</a>にてご確認ください。
        </p>

 <SubTitle :TitleName="'◆キャラクターの作成'" />
    <dl class="pa-3 ma-auto">
        <dt>(1) DLCをダウンロードした本体アカウントでゲームを起動してください。</dt>
        <dt>(2) トランジェルダで「訓練所」を選択してください。</dt>
        <dd>訓練所はキャラ作成・削除・職業変更などを行う施設です。</dd>
        <dt>(3) 「冒険者を登録」を選択してください。</dt>
          <dd>名前入力～職業選択といった冒険者作成フローを進めてください。</dd>
        <dt>(4)「使用するアイコンを選んでください」の画面で「顔アイコン」を選択してください。</dt>
        <dd>
          ここで「使用する顔アイコン」 選択画面に到達するので、画面右下の矢印を選択して顔アイコンの一覧を変更してください。
        </dd>
        <dt>(5) 特典の顔アイコンが選べるので選択して完了です。</dt>
        <dd>訓練所の冒険者リストに作成したキャラが追加されます。</dd>
      </dl>

 <SubTitle :TitleName="'◆顔アイコンの変更手順'" />
     <dl class="pa-3 ma-auto">
        <dt>(1) トランジェルダで「訓練所」を選択してください。</dt>
        <dt>(2)「名前を変える」という項目を選択してください。</dt>
        <dt>(3) 顔アイコンを変更したいキャラを選んでください。</dt>
        <dd>名前や性格の編集をし、「顔アイコン画像の変更をしますか？」で「はい」を選択します。</dd>
        <dt>(4) 「使用するアイコンを選んでください」の画面で「顔アイコン」を選択してください。</dt>
        <dd>
          ここで「使用する顔アイコン」 選択画面に到達するので
          画面右下の矢印を選択して顔アイコンの一覧を変更してください。
        </dd>
        <dt>(5) 特典の顔アイコンが選べるので選択して完了です。</dt>
        <dd>訓練所の冒険者リストに顔アイコン変更されたキャラが追加されます。</dd>
      </dl>
</div>
      </div>
      <AppFooter />
     
    </v-main>
  </v-app>
</template>

 <script>
  import AppFooter from "./AppFooter.vue";
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      AppFooter,
      SubTitle,
    },
  };
</script>

<style scoped>
  .d_area {
    border: #fff solid 1px;
    padding: 2em;
    margin: 2em auto !important;
    line-height: 2.5em;
    max-width: 1280px;
  }
  .d_area p {
    margin: 1em auto;
  }
  dt{line-height: 1.5em;}
  dd{text-indent: 1em; font-size: small;}
</style>
